import { ShareLineItemLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ShareLineItemLocationScreen />;
}
